// extracted by mini-css-extract-plugin
export default {"content":"Section_content__meiPN","light":"Section_light__rMYG0","dark":"Section_dark__YiufT","mixed":"Section_mixed__OGsx2"};